import React, { useEffect, useState } from 'react';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import { getFscSettingAudits } from 'utils/FscSettingsApiUtils';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';

const FCS_AUDIT_EVENTS = {
  CREATE: 'Create',
  EDIT: 'Edit',
  DELETE: 'Delete',
};

export default function Activity({ accountId }) {
  const { t } = useTranslation();

  const [audits, setAudits] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const formatEditMessage = (fcsAudit) => {
    const changes = JSON.parse(fcsAudit.message);
    const lineBreak = '&#013;';
    const formattedChanges = changes
      .map((change) => {
        return `${change.field}: ${change.oldValue} -> ${change.newValue}`;
      })
      .join(lineBreak);
    return `${t('FSC_CONFIG_EDITED_MESSAGE', {
      id: fcsAudit.fsc_config?.id,
    })}: ${lineBreak}${formattedChanges}${lineBreak}`;
  };

  const mapFcsAuditMessage = (fcsAudit) => {
    switch (fcsAudit.event) {
      case FCS_AUDIT_EVENTS.CREATE:
        return t('FSC_CONFIG_CREATED_MESSAGE', {
          id: fcsAudit.fsc_config?.id,
        });
      case FCS_AUDIT_EVENTS.DELETE:
        return t('FSC_CONFIG_DELETED_MESSAGE', {
          id: fcsAudit.fsc_config?.id,
        });
      case FCS_AUDIT_EVENTS.EDIT:
        return formatEditMessage(fcsAudit);
      default:
        return '';
    }
  };

  useEffect(() => {
    const fetchAudits = async () => {
      try {
        setIsLoading(true);
        const rows = await getFscSettingAudits(accountId, page, 100);

        const mapped = rows.map((el) => ({
          event: t(el.event.toUpperCase()),
          meta: { value: mapFcsAuditMessage(el) },
          user: { email: el.user },
          timestamp: el.createdAt,
        }));

        setAudits({
          items: mapped,
          totalCount: mapped.length,
        });
        setIsLoading(false);
      } catch (error) {
        showToast(
          t('PROBLEM_RETRIEVING_FSC_AUDITS'),
          t('RETRIEVING_FSC_AUDITS_ERROR', { error: error.message }),
          'error',
        );
        setIsLoading(false);
      }
    };
    fetchAudits();
  }, []);

  return (
    <AuditHistory
      audits={audits}
      paginate
      onClick={(page) => {
        setPage(page);
      }}
      currentPage={page}
      isLoading={isLoading}
    />
  );
}
